import {RankedPlacementState} from '@colonist/leaderboard-types'
import {GameColor} from '../../GameColor'
import {GameFont} from '../../GameFont'
import {TextView} from '../../ui_canvas_engine/TextView'
import {UIGameRankedEndController} from './UIGameRankedEndController'
import {BaseEndGameRankedChangeView} from './BaseEndGameRankedChangeView'
import {OpacityAnimationWrapper} from '../ui_game_animations/OpacityAnimationWrapper'
import {UIGameEndFooterController} from './UIGameEndFooterController.js'
import {TimeUtils} from '../../../../../shared/utils/TimeUtils'

export class GameEndPlacementChangeView extends BaseEndGameRankedChangeView {
    private readonly rankedState: RankedPlacementState
    private rankedUpdateTextView: TextView

    constructor(uiGameRankedEndController: UIGameRankedEndController, rankedState: RankedPlacementState, footerController: UIGameEndFooterController) {
        super(uiGameRankedEndController)
        this.rankedState = rankedState

        this.createPlacementUpdateText()

        footerController.fadeInButtons(4 * TimeUtils.MILLISECONDS)
    }

    private createPlacementUpdateText() {
        const updateText = this.rankedState.getEndGameScreenUpdateText()
        this.rankedUpdateTextView = new TextView(updateText, 0, 0, this.contentContainer.width, this.sectionSize, this.contentContainer, GameFont.Size.XXL, GameColor.getColor(GameColor.Color.Gray3), true)
        this.rankedUpdateTextView.centerXInParent()
        this.rankedUpdateTextView.centerYInParent()
        new OpacityAnimationWrapper(this.rankedUpdateTextView, this.uiGameRankedEndController.uiGameManager, 0, 1, 300, 2000)
    }

    hide() {
        this.rankedUpdateTextView.hide()
    }
}
